<docs>
  # Lenis SmoothScroll - https://github.com/studio-freight/lenis
  using lenis scroll in our way

  - it will only init if activated in our config.js
  - it will only init on desktop device

  @author Kevin Bastien <kevin@kffein.com>
</docs>

<script lang="ts">
import { defineComponent, ref, toRefs } from 'vue';
// import { useDebounceFn } from '@vueuse/core';
import { tryOnUnmounted, until } from '@vueuse/shared';
import { smoothScroll } from 'config';
import useFlow from 'utils/flow';
import { store as interfaceStore } from 'plugins/store/interface';
import loaderStore from 'components/ui/Loader/store';
import scrollStore from './store';

export default defineComponent({
  name: "SmoothScroll",
  setup() {
    const el = ref<HTMLElement>()
    const { done } = toRefs(loaderStore.state);
    // const { isDesktopDevice } = toRefs(interfaceStore);

    const { onInitUi } = useFlow()

    onInitUi( () => {
      // since this is inside our initUi, with without motion this will never be called.
      // init custom scroll only if activated inside our config file.
      // init custom scroll only on desktop device please
      if (!smoothScroll || !interfaceStore.isDesktopDevice) {
        until(done).toBe(true).then(() => {
          scrollStore.addEvents();
          scrollStore.setReady();
        });
      } else {
        until(done).toBe(true).then(() => {
          // const scroller: HTMLElement = document.querySelector(`body`) as HTMLElement;
          scrollStore.useSmoothScroll();
          
          // start observing a DOM node
          // resizeObserver.observe(scroller)
            // scrollStore.setScrollable(true);
          // });
        });
      }
      
    })

    tryOnUnmounted(()=>{
      scrollStore.releaseSmoothScroll(true)
    })

    // create an Observer instance
    // const resizeObserver = new ResizeObserver(useDebounceFn(() => {
    //   scrollStore.updateScroll()
    // }, 400))

    return {
      el,
    }
  }
});
</script>

<template>
  <div ref="el">
    <slot>
      App views here
    </slot>
  </div>
</template>

<style lang="stylus">

</style>
